import React, { useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'
import deviceIsMobile from '../../../lib/util/device-is-mobile'
import { MANUAL_SEARCH, SCAN_SEARCH, CASELESS_SEARCH } from '../../routing/paths'
import Button from '../../components/Button'

const SearchSwitch = () => {
  const history = useHistory()

  useEffect(() => {
    // redirects to manual search if user is on desktop
    /* if (!deviceIsMobile()) {
      history.push(MANUAL_SEARCH)
    } */
  }, [])

  return (
    <div className="flex-1 flex flex-col items-center justify-center">
      <img src="/icons/bootvision-logo-black.svg" alt="BootVision" className="mb-8" />
      {/* <Button as={Link} to={SCAN_SEARCH} extraStyle="w-full mb-2">
        Scan QR
      </Button> */}
      <Button as={Link} to={MANUAL_SEARCH} cancel extraStyle="w-full mb-2">
        Booted Vehicle Payment
      </Button>
      <Button as={Link} to={CASELESS_SEARCH} cancel extraStyle="w-full">
        Citation Payment
      </Button>
    </div>
  )
}

export default SearchSwitch
